/**
 * author: Soumya Shreyas
 */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  Button,
  Table,
  Form,
  Badge,
  Dropdown,
  OverlayTrigger,
} from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import { withTranslation } from "react-i18next";
import moment from "moment";
import { toast } from "react-toastify";
import {
  BiDownload,
  BiShareAlt,
  BiMenuAltRight,
  BiSearch,
  BiChevronDown,
  BiSort,
} from "react-icons/bi";
import { CgSortAz } from "react-icons/cg";
import { FcFinePrint } from "react-icons/fc";
import CompanyService from "../../../core/service/CompanyService";
import "./CompanyList.scss";
import Pagination from "../../../components/Pagination/Pagination";
import {
  DEFAULT_ITEMS_PER_PAGE,
  LIST_DEF_SORT,
  SORT_ORDER_DESC,
  STATUS,
} from "../../../core/constants/common";
import Utils from "../../../core/utilities/Utils";
import CompanyListingEditDropdown from "../../../components/CompanyListingEditDropdown";
// import ResendInvitationModal from "../../../components/ResendInvitationModal";
import InvitationService from "../../../core/service/InvitationService";
import { useNavigate } from "react-router-dom";
import ErrorHandlingService from "../../../core/service/ErrorHandlingService";
import nodataimg from "../../../images/nodatafound.png";
import ConfirmationModal from "../../../components/ConfirmationModal/ConfirmationModal";

function CompanyList({ t }) {
  const [itemsTotalCount, setItemTotalCount] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(DEFAULT_ITEMS_PER_PAGE);
  const [currentPage, setCurrentPage] = useState(1);
  const [companyList, setCompanyList] = useState([]);
  const [key, setKey] = useState("");
  const [order, setOrder] = useState(SORT_ORDER_DESC);
  const [sortField, setSortField] = useState(LIST_DEF_SORT);
  const [showResendModal, setShowResendModal] = useState(false);
  const [sendInvitationId, setSendInvitationId] = useState();
  const [sendInvitationEmail, setSendInvitationEmail] = useState();
  const [showConfirmation, setShowConfirmation] = useState(false);

  const [show, setShow] = useState(false);
  const [inviteId, setInviteId] = useState("");
  const [revokeItem, setRevokeItem] = useState("");
  const navigate = useNavigate();
  let messageConfirmation = t("RevokeConfirmationMessage.label");

  const handleClose = () => setShow(false);
  const handleResendConfirm = () => {
    setShow(false);
    resendInvitaion();
  };

  useEffect(() => {
    getCompanies(0, itemsPerPage, key, sortField);
  }, []);
  const resendInvitaion = () => {
    InvitationService.resendInvitation(sendInvitationId)
      .then((response) => {
        if (response.status === 200) {
          toast.success("Sent Invitation", {
            position: toast.POSITION.TOP_RIGHT,
          });
        }
      })
      .catch((error) => {
        //ErrorHandlingService.handleError(error.response.status);
        //  console.log("err", error);
      });
  };

  const getCompanies = (pageNumber, itemsPerPageVal, key, sortField) => {
    if (pageNumber > 0) {
      pageNumber = pageNumber - 1;
    } else {
      setCurrentPage(1);
    }
    if (itemsPerPageVal > 0) {
      var perPage = itemsPerPageVal;
    } else {
      var perPage = itemsPerPage;
    }
    var sort = sortField + "," + order;
    CompanyService.listCompany(pageNumber, perPage, key, sort)
      .then((response) => {
        var totalPages = parseFloat(response.headers["x-total-count"]);
        setItemTotalCount(totalPages);
        setCompanyList([...response.data]);
      })
      .catch((error) => {
        //ErrorHandlingService.handleError(error.response.status);
        //  console.log("err", error);
      });
  };
  const handleSearch = (e) => {
    var searchKey = e.target.value;
    setKey(searchKey);
    getCompanies(0, itemsPerPage, searchKey, sortField);
  };
  const handleSort = (val) => {
    if (sortField === val && order === "asc") {
      setOrder("desc");
    } else {
      setOrder("asc");
    }
    setSortField(val);
    getCompanies(0, itemsPerPage, key, val);
  };
  const handleCallbackRevoke = (item) => {
    setRevokeItem(item);
    setShowConfirmation(true);
  }
  const callbackRevoke = (val) => {
    setShowConfirmation(false);
    if (val) {
      InvitationService.resendInvitation(revokeItem, "REVOKED")
        .then((response) => {
          if (response.status === 200) {
            toast.success("Success", {
              position: toast.POSITION.TOP_RIGHT,
            });
            getCompanies(0, itemsPerPage, key, sortField);
          }
        })
        .catch((error) => { });
    }
  };
  var resendStatus = false;
  var editStatus = false;
  var sendInviteBool = false;
  var revokeStatus = false;
  return (
    <>
      <div className="CompanyList">
        <div className="List_header">
          <h5 className="MH">{t("Companies.label")}</h5>
          <div className="List_sorts_menu">
            <ul>
              <li>
                <Link to="#">
                  <button className="btn btn-secondary"><CgSortAz /> {t("Filter.label")}</button>
                </Link>
              </li>
              <li>
                <Link to="/admin/create_company">
                  {" "}
                  <Button variant="primary">
                    {t("AddCompany.label")}
                  </Button>
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="List_Table_01">
          <div className="List_table-card01_head">
            <div className="List_table-card_Search_01">
              <div className="List_table-card_Search_Box">
                <Form>
                  <input
                    type="text"
                    className="form-control"
                    value={key}
                    onChange={handleSearch}
                    placeholder="Search Here"
                  />
                  {/* <Link to="#" className="Search_iocnBox">
                    <BiSearch value={key} onClick={handleSearch}/>
                  </Link> */}
                </Form>
              </div>
            </div>
            <div className="List_table-card01_sort">
              <ul>
                {/* <li>
                  <Link to="#">
                    <BiShareAlt /> Share
                  </Link>
                </li> */}
                <li className="filter">

                </li>
              </ul>
            </div>
          </div>
          <div className="card List_table-card01">
            <Table responsive="sm">
              <thead>
                <tr>
                  <th className="th_check">
                    {/* <Form.Check
                      inline
                      name="group1"
                      type="checkbox"
                      id="inline-checkbox-1"
                    /> */}
                  </th>
                  <th>

                    <Link to="#" onClick={() => handleSort("legalName")}>
                      {t("CompanyName.label")}
                      <BiSort />
                    </Link>

                  </th>
                  <th>
                    <Link to="#" onClick={() => handleSort("email")}>
                      {t("Email.label")}
                      <BiSort />
                    </Link>{" "}
                  </th>
                  <th>{t("ContactNumber.label")}</th>
                  <th>
                    <Link to="#" onClick={() => handleSort("createdDate")}>
                      {t("CreatedDate.label")}
                      <BiSort />
                    </Link>
                  </th>
                  <th>
                    <Link to="#" onClick={() => handleSort("invitationStatus")}>
                      {t("Onboarding.label")}
                      <BiSort />
                    </Link>
                  </th>
                  {/* <th>{t("Forms.label")}</th>
                  <th>{t("Risk.label")}</th> */}
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {companyList.length > 0 ? (
                  companyList?.map((item) => (
                    <tr key={item.invitationId}>
                      <td className="checkbox">
                        {" "}
                        {/* requires later */}
                        {/* <Form.Check
                          inline
                          name="group1"
                          type="checkbox"
                          id="inline-checkbox-1"
                        /> */}
                      </td>
                      <td>
                        <OverlayTrigger
                          placement="top"
                          overlay={Utils.renderTooltip(
                            t("Clicktoviewcompanydetails.label")
                          )}
                        >
                          <Link to="/admin/company_profile">
                            {item.legalName}
                          </Link>
                        </OverlayTrigger>
                        <p className="m-0">{item.countryName}</p>
                      </td>
                      <td>{item.email}</td>
                      <td>
                        +{item.phoneNumber.code.phoneCode}{" "}
                        {item.phoneNumber.number}
                      </td>
                      <td>{moment(item.createdDate).format("MMM DD, YYYY")}</td>
                      <td>
                        {(() => {
                          resendStatus = false;
                          editStatus = false;
                          revokeStatus = false;

                          switch (item.invitationStatus) {
                            case "ONBOARDED":
                              return (
                                <Badge bg="badge-Onboarded">
                                  {STATUS[item.invitationStatus]}
                                </Badge>
                              );
                            case "INVITED":
                              editStatus = true;
                              resendStatus = true;
                              sendInviteBool = true;
                              revokeStatus = true;
                              return (
                                <Badge bg="badge-Invited">
                                  {STATUS[item.invitationStatus]}
                                </Badge>
                              );
                            case "ACCEPTED":
                              return (
                                <Badge bg="badge-Accepted">
                                  {STATUS[item.invitationStatus]}
                                </Badge>
                              );
                            case "COMPLETED":
                              return (
                                <Badge bg="badge-Completed">
                                  {STATUS[item.invitationStatus]}
                                </Badge>
                              );
                            case "DRAFT":
                              editStatus = true;
                              sendInviteBool = false;
                              return (
                                <Badge bg="badge-Draft">
                                  {STATUS[item.invitationStatus]}
                                </Badge>
                              );
                            default:
                              return " ";
                          }
                        })()}
                      </td>
                      {/* <td>
                      3/3{" "}
                      <span className="Font-20">
                        <BiChevronDown />
                      </span>
                    </td>
                    <td>
                      <Badge bg="badge-Low">Low</Badge>
                    </td> */}
                      <td>
                        {(editStatus || resendStatus || revokeStatus) && (
                          <CompanyListingEditDropdown
                            editStatus={editStatus}
                            resendStatus={resendStatus}
                            revokeStatus={revokeStatus}
                            invitation={item.invitationId}
                            handleResend={() => {
                              setSendInvitationId(item.invitationId);
                              setShow(true);
                              setSendInvitationEmail(item.email);
                            }}
                            handleEdit={() => {
                              const myData = {
                                id: item.invitationId,
                                legalName: item.legalName,
                                name: item.contactName,
                                email: item.email,
                                contactNumber: {
                                  id: item.phoneNumber.code.id,
                                  code: {
                                    id: item.phoneNumber.code.phoneCode,
                                    name: item.phoneNumber.code.name,
                                  },
                                  number: item.phoneNumber.number,
                                },
                                sendInvite: sendInviteBool,
                                supplierType: null,
                              };
                              navigate("/admin/edit_company", {
                                state: myData,
                              });
                            }}
                            handleRevoke={() => {
                              handleCallbackRevoke(item.invitationId)
                            }}
                          />
                        )}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="9" className="text-center">
                      <div className="Nodatafound_box">
                        <h6><FcFinePrint className="me-2" /> {t("Nodatafound.label")}</h6>
                      </div>
                    </td>
                  </tr>
                )}
                {/* {console.log("showResendModal ",showResendModal)} */}
                {/* {showResendModal && (
                  <ResendInvitationModal
                    modalShow={true}
                    invitationId={sendInvitationId}
                    email = {sendInvitationEmail}
                  />
                )} */}
                <Modal show={show} onHide={handleClose}>
                  <Modal.Header closeButton>
                    <Modal.Title as="h5"></Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    {t("ResendInvitation.label") + " " + sendInvitationEmail}
                  </Modal.Body>
                  <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose} autoFocus>
                      {t("Cancel.label")}
                    </Button>
                    <Button variant="primary" onClick={handleResendConfirm} className="sbmBtn">
                      {t("Send.label")}
                    </Button>
                  </Modal.Footer>
                </Modal>
              </tbody>
            </Table>
            <div className="p-2 List_footer_count">
              <Pagination
                itemsTotalCount={itemsTotalCount}
                itemsPerPage={itemsPerPage}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                alwaysShown={true}
                setItemsPerPage={setItemsPerPage}
                pageClicked={(pageNum, perPage) => {
                  getCompanies(pageNum, perPage, key, sortField);
                }}
              />
            </div>
          </div>
        </div>
        {showConfirmation && (
          <ConfirmationModal
            modalShow={true}
            messageText={messageConfirmation}
            callbackModal={callbackRevoke}
            confirmBtn={t("Confirm.label")}
            CancelBtn={t("Cancel.label")}
          />
        )}
      </div>
    </>
  );
}

export default withTranslation()(CompanyList);
